import PlanGraph from "../../Components/PlanGraph/PlanGraph";
import { Grid2 } from "@mui/material";
import PlanUsageStyle from "./PlanUsageStyle.module.scss";
import UpcomingInvoice from "../../Components/UpcomingInvoice/UpcomingInvoice";
import Addon from "../../Components/Addon/Addon";
function PlanUsage(props) {
  const { upcomingInvoice, specificPlan, dedicatedHosting } = props;

  const addonPlan = Array.isArray(specificPlan)
    ? specificPlan.filter((plan) => plan.basePlan === false)
    : [];

  const addonDataWithoutWaf = Array.isArray(specificPlan)
    ? specificPlan.filter(
        (plan) => plan.basePlan === false && plan?.licenseType !== "Waf"
      )
    : [];

  const baseSingleSitePlan = Array.isArray(specificPlan)
    ? specificPlan.filter(
        (plan) => plan.basePlan === true && plan.isSingleSite === true
      )
    : [];

  return (
    <Grid2 className={PlanUsageStyle.container}>
      <Grid2>
        <PlanGraph specificPlan={specificPlan} />
      </Grid2>

      {!dedicatedHosting && (
        <>
          <Grid2 className={PlanUsageStyle.headerLine}></Grid2>
          <Grid2 className={PlanUsageStyle.addon}>
            <Addon invoiceItems={addonPlan} addonData={addonDataWithoutWaf} />
          </Grid2>
        </>
      )}

      <Grid2 className={PlanUsageStyle.headerLine}></Grid2>
      <Grid2 className={PlanUsageStyle.invoice}>
        <UpcomingInvoice
          planPrice={upcomingInvoice?.basePlan?.price}
          additionalSitePrice="0.00"
          additionalSiteCount="0"
          WAFCount="1"
          WAFPrice="FREE"
          AddonCount="0"
          AddonPrice="0.00"
          TaxAmount={upcomingInvoice?.tax}
          estimatedBill={upcomingInvoice?.estimatedBill}
          singleSitePlan={baseSingleSitePlan?.[0]?.singleSite}
        />
      </Grid2>
    </Grid2>
  );
}

export default PlanUsage;
